import { registerPageInit } from '../barba/page-init-registry';
import '../../css/pages/clusters/clusters.scss';
import { mountClustersInteractiveMap } from '@/js/utils/init-clusters-interactive-map';
import { destroyClusterSpa, initClusterSpa } from '@/js/utils/cluster-spa';

registerPageInit('clusters', () => {
  mountClustersInteractiveMap();
  initClusterSpa();
});

window.addEventListener('stc:barba-before-leave', () => {
  if (document.querySelector('.clusters-page--spa')) {
    destroyClusterSpa();
  }
});
